// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__4-PLY","slider":"ToggleSwitch_slider__Lq1xR","round":"ToggleSwitch_round__8I6cc"};